import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49499353"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-p-2 child-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MasterDataColumns = _resolveComponent("MasterDataColumns")!
  const _component_DialogDelete = _resolveComponent("DialogDelete")!
  const _component_MasterDataColumnsForm = _resolveComponent("MasterDataColumnsForm")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_EntryDialog = _resolveComponent("EntryDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_MasterDataColumns, {
        masterDataColumns: _ctx.masterDataColumns,
        loading: _ctx.loading,
        onOnClickDelete: _ctx.openDeleteDialog,
        onOnEntrySelect: _ctx.onEntrySelect,
        onOnResetClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showResetDialog = true)),
        onOnChangeInputField: _ctx.onChangeInputField,
        permissions: _ctx.permissions
      }, null, 8, ["masterDataColumns", "loading", "onOnClickDelete", "onOnEntrySelect", "onOnChangeInputField", "permissions"])
    ]),
    _createVNode(_component_DialogDelete, {
      showDialog: _ctx.deleteDialog,
      onOnClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteDialog = false)),
      onOnConfirm: _ctx.deleteEntry
    }, null, 8, ["showDialog", "onOnConfirm"]),
    _createVNode(_component_EntryDialog, {
      show: _ctx.showDialog,
      onOnClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDialog = false, _ctx.isValidationInvalid = true, _ctx.showValidationMessage = false)),
      onOnConfirm: _ctx.saveMasterDataColumn,
      loading: _ctx.loadingDialog,
      headerText: _ctx.headerText,
      showKeepDialogOpen: !_ctx.masterDataColumn.id
    }, {
      content: _withCtx(() => [
        _createVNode(_component_BlockUI, { blocked: _ctx.loadingDialog }, {
          default: _withCtx(() => [
            _createVNode(_component_MasterDataColumnsForm, {
              ref: "masterDataColumnForm",
              masterDataColumn: _ctx.masterDataColumn,
              onUpdate: _ctx.onUpdate,
              showErrorMessage: _ctx.showValidationMessage
            }, null, 8, ["masterDataColumn", "onUpdate", "showErrorMessage"])
          ]),
          _: 1
        }, 8, ["blocked"])
      ]),
      _: 1
    }, 8, ["show", "onOnConfirm", "loading", "headerText", "showKeepDialogOpen"]),
    _createVNode(_component_EntryDialog, {
      show: _ctx.showResetDialog,
      onOnClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showResetDialog = false)),
      onOnConfirm: _ctx.resetTable,
      loading: _ctx.loadingResetDialog,
      headerText: _ctx.$t('Squeeze.MasterData.CreateResetTable'),
      saveButtonText: _ctx.$t('Squeeze.General.Execute')
    }, {
      content: _withCtx(() => [
        _createElementVNode("b", null, _toDisplayString(_ctx.$t('Squeeze.MasterData.Attention')), 1),
        _createTextVNode(": " + _toDisplayString(_ctx.$t('Squeeze.MasterData.CreateResetTableConfirm')), 1)
      ]),
      _: 1
    }, 8, ["show", "onOnConfirm", "loading", "headerText", "saveButtonText"])
  ], 64))
}